export const LMT_ENHCMT_updatePreviousScreenReducer = {
  LMT_ENHCMT_updatePreviousScreen: (state, action) => {
    state.previousScreen = action.payload;
  },
};
